import { ImportCsvRequest, ImportCsvResponse } from '@/types'
import { CreateMachineRequest } from '@/types/apis/machines/CreateMachineRequest'
import { CreateMachineResponse } from '@/types/apis/machines/CreateMachineResponse'
import { DeleteMachineRequest } from '@/types/apis/machines/DeleteMachineRequest'
import { DeleteMachineResponse } from '@/types/apis/machines/DeleteMachineResponse'
import { GetAllMachinesResponse } from '@/types/apis/machines/GetAllMachinesResponse'
import { GetMachineRequest } from '@/types/apis/machines/GetMachineRequest'
import { GetMachineResponse } from '@/types/apis/machines/GetMachineResponse'
import { UpdateMachineRequest } from '@/types/apis/machines/UpdateMachineRequest'
import { UpdateMachineResponse } from '@/types/apis/machines/UpdateMachineResponse'

import axios from './axios'

const API_ENDPOINT = '/washing-machine'

export const getAllMachines = (): Promise<GetAllMachinesResponse> => {
  return axios.get(`${API_ENDPOINT}`)
}

export const getMachine = (request?: GetMachineRequest): Promise<GetMachineResponse> => {
  return axios.get(`${API_ENDPOINT}${request?.id ? `/${request.id}` : ''}`)
}

export const createMachine = (request: CreateMachineRequest): Promise<CreateMachineResponse> => {
  return axios.post(API_ENDPOINT, request)
}

export const updateMachine = (request: UpdateMachineRequest): Promise<UpdateMachineResponse> => {
  return axios.put(`${API_ENDPOINT}/${request.id}`, request)
}

export const deleteMachine = (request: DeleteMachineRequest): Promise<DeleteMachineResponse> => {
  return axios.delete(`${API_ENDPOINT}/${request.id}`)
}

export const importCsvMachineApi = (request: ImportCsvRequest): Promise<ImportCsvResponse> => {
  return axios.post(`${API_ENDPOINT}/import-csv`, request)
}

export const importCsvTankToMachineApi = (request: ImportCsvRequest): Promise<ImportCsvResponse> => {
  return axios.post(`${API_ENDPOINT}/import-csv/tank`, request)
}
